<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button [Form]="Form" [Parent]="this" (click)="Save()"></app-form-save-button>
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Session Details
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="Valet Station" [Required]="true">
              <div class="control is-expanded mb-2">
                <div class="select is-fullwidth">
                  <select class="input is-fullwidth" formControlName="ValetStationId">
                    @for (c of ValetStations; track c) {
                      <option [ngValue]="c.Id">
                        {{c.Name}}
                      </option>
                    }
                  </select>
                </div>
              </div>
            </app-field>
            <app-field Label="Key State">
                <div class="control is-expanded mb-2">
                    <div class="select is-fullwidth">
                        <select class="input is-fullwidth" formControlName="KeyState">
                            <option [ngValue]="0">Out</option>
                            <option [ngValue]="1">In Storage</option>
                            <option [ngValue]="2">With Staff</option>
                        </select>
                    </div>
                </div>
            </app-field>
            @if (ValetTypes) {
              <app-field Label="Valet Type">
                <div class="control is-expanded mb-2">
                  <div class="select is-fullwidth">
                    <select class="input is-fullwidth" formControlName="ValetTypeId">
                      <option [ngValue]="null">-- None --</option>
                      @for (t of ValetTypes; track t) {
                        <option [ngValue]="t.Id">{{t.Name}}</option>
                      }
                    </select>
                  </div>
                </div>
              </app-field>
            }
            <app-field Label="Key Tag Identifier">
              <p class="control mb-2">
                <input formControlName="KeyTagIdentifier" class="input is-fullwidth" type="text" />
              </p>
            </app-field>
            <app-field Label="Vehicle" [HasAddons]="true" [Required]="true" tippy="">
              <div class="control mb-2">
                <div class="field is-grouped is-grouped-multiline">
                  <div class="field is-grouped is-grouped-multiline">
                    @if (Model.VehicleId != null) {
                      <div class="tags has-addons">
                        <a class="tag">{{Model.VehicleColorName}} {{Model.VehicleBrandName}} {{Model.VehicleModelName}} ({{Model.PlateNumber}})</a>
                        <a class="tag" (click)="RemoveVehicle()"><i class="fa fa-trash"></i></a>
                      </div>
                    }
                    <div class="tags has-addons">
                      @if (Model.VehicleId == null) {
                        <a class="tag button is-primary" (click)="AddVehicle()">Add</a>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </app-field>
            <app-field Label="Rate Set">
              <div class="control is-expanded mb-2">
                <div class="select is-fullwidth">
                  <select class="input is-fullwidth" formControlName="ParkingRateSetId">
                    <option [ngValue]="null">None</option>
                    @for (r of RateSets; track r) {
                      <option [ngValue]="r.Id">{{r.Name}}</option>
                    }
                  </select>
                </div>
              </div>
            </app-field>
          </div>
        </article>
      </div>
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Customer Details
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="First Name">
              <p class="control mb-2">
                <input formControlName="CustomerFirstName" class="input is-fullwidth" type="text" />
              </p>
            </app-field>
            <app-field Label="Last Name">
              <p class="control mb-2">
                <input formControlName="CustomerLastName" class="input is-fullwidth" type="text" />
              </p>
            </app-field>
            <app-field Label="Phone Number">
              <p class="control mb-2">
                <input formControlName="CustomerPhoneNumber" class="input is-fullwidth" type="tel" maxlength="20" pattern="\d*" (keypress)="$event.charCode >= 48 && $event.charCode <= 57 || $event.charCode === 0" />
              </p>
            </app-field>
          </div>
        </article>
      </div>
    </div>
  </div>
}
